import React from 'react';

type OvivaSpecialProps = {
  titleDesktop?: string;
  titleMobile?: string;
  subtitle?: string;
  bulletPoints?: string[];
};

const OvivaSpecial = ({
  titleDesktop = 'Was Oviva so anders macht als herkömmliche Abnehmprogramme?',
  titleMobile = 'Was macht Oviva besonders?',
  subtitle = 'Fast alles – hier ein kurzer Überblick',
  bulletPoints = [
    'Krankenkasse zahlt Programm',
    'Wirksamkeit durch Studie belegt',
    'Kein stressiges Kalorienzählen',
    'Keine Verbote',
  ],
}: OvivaSpecialProps) => {
  return (
    <div className="oviva-special-component px-[20px] py-[40px] md:px-[54px] md:py-[80px] flex flex-col items-center">
      <div className="">
        <h2 className="mb-3 mt-0 text-[24px] md:hidden">{titleMobile}</h2>
        <h2 className="mb-6 mt-0 text-center text-[44px] hidden md:block">{titleDesktop}</h2>
        {subtitle && <p className="h5 md:text-center">{subtitle}</p>}
      </div>
      <div className="grid grid-cols-[1fr_90px_90px] md:grid-cols-[1fr_120px_120px] bg-[#E8F5E9] max-w-[600px] rounded-[10px] mt-8">
        <div className="h-[60px]"></div>
        <div className="bg-white text-center font-semibold text-[20px] flex items-center justify-center">
          Oviva
        </div>
        <div className="text-center font-semibold text-[20px] flex items-center justify-center">
          Andere
        </div>

        {bulletPoints.map((item) => (
          <React.Fragment key={item}>
            <div className="px-3 py-4 md:px-[25px] min-h-[60px] flex items-center text-[16px] font-semibold">
              {item}
            </div>
            <div className="bg-white flex items-center justify-center">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1_5710)">
                  <circle cx="20" cy="20" r="20" fill="#0DCBAA" />
                  <path
                    d="M29.0317 11.4431C29.7423 10.7327 30.8769 10.7326 31.5874 11.4431C32.2978 12.1536 32.2977 13.2882 31.5874 13.9988L16.7358 28.8367C16.0253 29.5473 14.8761 29.5473 14.1655 28.8367L8.29443 22.9666C7.58385 22.256 7.58385 21.1205 8.29443 20.4099C9.00502 19.6993 10.1405 19.6993 10.8511 20.4099L15.4575 25.0173L29.0317 11.4431Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1_5710">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="flex items-center justify-center">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1_5709)">
                  <circle cx="20" cy="20" r="20" fill="#CCCCCC" />
                  <path
                    d="M13.6147 12.1123C12.9042 11.4017 11.7687 11.4017 11.0581 12.1123C10.348 12.8228 10.3479 13.9575 11.0581 14.668L25.9106 29.5059C26.6212 30.2161 27.7695 30.2162 28.48 29.5059C29.1906 28.7953 29.1905 27.6608 28.48 26.9502C27.7728 26.243 27.1945 25.6909 27.189 25.6855L13.6147 12.1123Z"
                    fill="#BCBCC0"
                  />
                  <path
                    d="M25.9248 12.1123C26.6354 11.4017 27.7699 11.4017 28.4805 12.1123C29.1911 12.8229 29.1911 13.9574 28.4805 14.668L13.6289 29.5059C12.9183 30.2163 11.7691 30.2164 11.0586 29.5059C10.3482 28.7953 10.349 27.6607 11.0596 26.9502C11.7701 26.2397 12.3506 25.6855 12.3506 25.6855L25.9248 12.1123Z"
                    fill="#BCBCC0"
                  />
                  <path
                    d="M25.9248 11.4417C26.6353 10.7311 27.7699 10.7313 28.4805 11.4417C29.1911 12.1522 29.1911 13.2877 28.4805 13.9983L13.6289 28.8352C12.9183 29.5458 11.7692 29.5458 11.0586 28.8352C10.3484 28.1246 10.3492 26.991 11.0596 26.2805C11.7646 25.5755 12.3416 25.0245 12.3506 25.0159L25.9248 11.4417Z"
                    fill="white"
                  />
                  <path
                    d="M13.6157 11.4419C12.9051 10.7313 11.7697 10.7313 11.0591 11.4419C10.3488 12.1525 10.3496 13.2871 11.0601 13.9976L25.9116 28.8354C26.6222 29.546 27.7713 29.546 28.4819 28.8354C29.1922 28.1248 29.1914 26.9903 28.481 26.2798C27.7705 25.5693 27.1899 25.0151 27.1899 25.0151L13.6157 11.4419Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1_5709">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </React.Fragment>
        ))}
        <div></div>
        <div className="bg-white h-[20px]"></div>
        <div></div>
      </div>
    </div>
  );
};
export default OvivaSpecial;
